export default theme => ({
    titleContainer: {
        display: 'flex',
        flex: 1,
        flexDirection: 'row',
        alignItems: 'center',
        color: '#fff',
        overflow: 'hidden'
    },

    appBar: {
        zIndex: 99999
    },

    toolbar: {
        backgroundColor: '#4CAF50',
        minHeight: 'initial',
        zIndex: 9999
    },

    menuButton: {
        color: '#fff',
        paddingTop: '1.5em',
        paddingBottom: '1.5em'
    },

    iconMenuButton: {
        color: '#fff'
    },

    link: {
        color: '#fff',
        textDecoration: 'none'
    },

    crumbContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        [theme.breakpoints.down('xs')]: {
            display: 'none'
        }
    }
})
